import React from "react";
import { useHistory } from "react-router-dom";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import MobileAppStoreMenu from "../../../components/MobileAppStoreMenu/MobileAppStoreMenu";
import { ANDROID_APP_OPTIONS, IOS_APP_OPTIONS } from "../../../constants/mobileApps";
import { getSupportEmail } from "../../../utils/siteBrand";
import "./home-landing.css";

const PRODUCT = [
  { label: "Home", href: "#/montessori/home" },
  { label: "Problems we solve", href: "#/montessori/problenwesolve" },
  { label: "School registration", href: "#/montessori/schoolregistration" },
  { label: "Log in", href: "#/montessori/login" },
];
const COMPANY = [
  { label: "About us", href: "#/montessori/about" },
  { label: "Delete account enquiry", href: "#/montessori/delete-news-enquiry" },
];
const SUPPORT = [
  { label: "Privacy policy", href: "#/montessori/privacy" },
  { label: "Refund and cancellation policy", href: "#/montessori/refund-cancellation" },
  { label: "Terms of service", href: "#/montessori/term" },
];

const Column = ({ title, links }) => (
  <nav aria-label={title}>
    <h4 className="lh-ft__h">{title}</h4>
    <ul>
      {links.map(({ label, href }) => (
        <li key={label}>
          <a href={href}>{label}</a>
        </li>
      ))}
    </ul>
  </nav>
);

const CtaFooter = () => {
  const history = useHistory();
  const supportEmail = getSupportEmail();

  return (
    <footer className="lh-ft">
      <div className="lh-wrap">
        <div className="lh-ft__cta">
          <h2>
            Let&apos;s make your school <br />
            day calmer.
          </h2>
          <button type="button" className="lh-ft__round" onClick={() => history.push("/montessori/schoolregistration")}>
            Start free trial
            <ArrowForwardIcon fontSize="small" />
          </button>
        </div>

        <div className="lh-ft__grid">
          <Column title="Product" links={PRODUCT} />
          <Column title="Company" links={COMPANY} />
          <Column title="Support" links={SUPPORT} />
          <div>
            <h4 className="lh-ft__h">Contact</h4>
            <p className="lh-ft__c">
              <EmailIcon fontSize="small" /> <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
            </p>
            <p className="lh-ft__c">
              <PhoneIcon fontSize="small" /> <span>+91 8247625893</span>
            </p>
            <div className="lh-ft__stores">
              <MobileAppStoreMenu options={IOS_APP_OPTIONS}>
                <span className="lh-ft__store" role="button" tabIndex={0} aria-label="Download on the App Store">
                  <img src="/images/apple logo.svg" alt="" />
                </span>
              </MobileAppStoreMenu>
              <MobileAppStoreMenu options={ANDROID_APP_OPTIONS}>
                <span className="lh-ft__store" role="button" tabIndex={0} aria-label="Get it on Google Play">
                  <img src="/images/android logo.svg" alt="" />
                </span>
              </MobileAppStoreMenu>
            </div>
          </div>
        </div>

        <div className="lh-ft__bottom">
          <span>© {new Date().getFullYear()} Montestory. All rights reserved.</span>
          <span>Built for Montessori schools</span>
        </div>
      </div>
      <div className="lh-ft__word" aria-hidden="true">montestory</div>
    </footer>
  );
};

export default CtaFooter;
